require([
	"csi/skintheme/ArcticFresh",
	"csi/skintheme/CentricBlue",
	"csi/skintheme/DragonFruit",
	"csi/skintheme/Dusk",
	"csi/skintheme/Indigo",
	"csi/skintheme/Luxe",
	"csi/skintheme/OceanWave",
	"csi/skintheme/SeaBreeze",
	"csi/skintheme/Spearmint",
	"csi/skintheme/StarryNight",
	"csi/skintheme/SunsetBoulevard",
	"csi/skintheme/VioletMist"
]);